import { render, staticRenderFns } from "./ReleaseUpload.vue?vue&type=template&id=046238d3&scoped=true&"
import script from "./ReleaseUpload.vue?vue&type=script&lang=js&"
export * from "./ReleaseUpload.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseUpload.vue?vue&type=style&index=0&id=046238d3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046238d3",
  null
  
)

export default component.exports